// extracted by mini-css-extract-plugin
export default {"searchIcon":"StickySearch__searchIcon--2-Z","searchBlock":"StickySearch__searchBlock--1vN","overlay":"StickySearch__overlay--3VK"};